import { render, staticRenderFns } from "./Revenu.vue?vue&type=template&id=2106286a&"
import script from "./Revenu.vue?vue&type=script&lang=js&"
export * from "./Revenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports